import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useUpdateInvoiceItemRate } from '@/core/domain/invoice/invoiceItem/invoiceItem.hook';
import { useRouteMatchParam } from '@/hooks';
import { Col, Form, Modal, Row } from 'antd';

interface Props {
  open: boolean;
  onCancel: () => void;
}

const NoteItemsSelectAliquotModal = ({ open, onCancel }: Props) => {
  const [form] = Form.useForm();

  const updateInvoiceItemRate = useUpdateInvoiceItemRate();

  const invoiceId = useRouteMatchParam('invoiceId');

  async function handleSubmit() {
    try {
      await updateInvoiceItemRate.mutateAsync({
        invoiceId: Number(invoiceId),
        rate: form.getFieldValue('rate'),
      });

      onCancel();
    } catch {}
  }

  return (
    <Modal
      destroyOnClose
      title="Valor da alíquota"
      open={open}
      onCancel={() => onCancel()}
      onOk={handleSubmit}
      okText="Salvar"
      confirmLoading={updateInvoiceItemRate.isLoading}
      closable={!updateInvoiceItemRate.isLoading}
      maskClosable={!updateInvoiceItemRate.isLoading}
    >
      <Form form={form} preserve={false}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem name="rate" label="Alíquota">
              <InputDecimal
                fractions={4}
                disabled={updateInvoiceItemRate.isLoading}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default NoteItemsSelectAliquotModal;
